import confetti from 'canvas-confetti'

const randomInRange = (min: number, max: number) => {
  return Math.random() * (max - min) + min
}

export const triggerConfetti = () => {
  Array.from({ length: 5 }).forEach((_, i) => {
    setTimeout(() => {
      confetti({
        angle: randomInRange(55, 125),
        spread: randomInRange(50, 70),
        particleCount: randomInRange(50, 100),
        origin: { y: randomInRange(0.6, 0.3), x: randomInRange(0.6, 0.3) },
        zIndex: 10000,
        disableForReducedMotion: true,
      })
    }, i * 150)
  })
}
